
import React, { Component } from 'react';
import './About.css';
import imageOne from '../../static/mission_work1.jpg';
import imageTwo from '../../static/mission_work2.jpg';
import imageThree from '../../static/mission_work3.jpg';

class About extends Component {

  render() {
    return (

      <div id="about">
        <section className="about-hero secondaryhero">
          <div className="container">
            <h1>About CPAK Inc.</h1>
          </div>
        </section>
        <div className="collage">
          <img src={imageOne} alt=""/>
          <img src={imageTwo} alt=""/>
          <img src={imageThree} alt=""/>
        </div>
        <section className="about-cpak">
          <div className="container">
            <h4>About CPAK</h4>
            <p>
              CPAK, in the language of industrial packaging is synonymous with excellence.
              CPAK’s founder, owner, and operator, Chris Callas has over 35 years of expertise
              in the industrial packaging industry as a Manufacturers representative and
              packaging consultant to some of the largest chemical and paint companies in
              the state of Michigan.
              <br /><br />
              The original Callas family business was sold in 2010, at best to be newly
              established as CPAK in 2014. With long standing, trusted, relationships in
              the industry, Chris was intent on rebuilding and renewing a sense of security
              in the hearts of his foregoing and new customers alike.
              <br /><br />
              Our mission is to establish and maintain personal relationships with those that
              we do business with. Breaking the gap between business and personal relationships
              is at the forefront of our establishment. CPAK is the destruction of the deceptive
              day to day, business to business world. Our products are outmatched, our service
              will exceed expectation, our family is your family.
            </p>
          </div>
        </section>
      </div>
    )
  }
}

export default About;



/** WEBPACK FOOTER **
 ** ./src/components/About/About.js
 **/